import api, { apiMagazine, baseUrlMagazine } from "./index";
import axios from "axios"; // send sms to phone number

export var verifyPhone = function verifyPhone(CellPhoneNum) {
  // const Url = `${baseUrl}/user/check-mobile`;
  var options = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    url: '/v1/auth/login',
    data: {
      CellPhoneNum: CellPhoneNum
    }
  };
  return api(options);
}; // check sms sent tp phone number

export var verifyCode = function verifyCode(Code, token) {
  // const Url = `${baseUrl}/user/check-mobile`;
  var options = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    method: 'PATCH',
    url: '/v1/auth/verify-mobile',
    data: {
      code: Code
    }
  };
  return api(options);
}; // login with kanoon account

export var loginKanoon = function loginKanoon(username, password, fromApp) {
  var options = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    url: '/v1/auth/login-kanooniha',
    data: {
      username: username,
      password: password,
      fromApp: fromApp
    }
  };
  return api(options);
}; // register

export var register = function register(Name, Family, Username, Password, CellphoneNumber, CountryCode, State, MainCode, GroupCode, AreaCode, Sex, IsStu, FromApp, token) {
  var options = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    method: 'PATCH',
    url: '/v1/auth/register',
    data: {
      Name: Name,
      Family: Family,
      Username: Username,
      Password: Password,
      CellphoneNumber: CellphoneNumber,
      CountryCode: CountryCode,
      State: State,
      MainCode: MainCode,
      GroupCode: GroupCode,
      AreaCode: AreaCode,
      Sex: Sex,
      IsStu: IsStu,
      FromApp: FromApp
    }
  };
  return api(options);
}; // log out

export var logOut = function logOut(token) {
  // const Url = `${baseUrl}/user/check-mobile`;
  var options = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    method: 'GET',
    url: '/v1/auth/logout'
  };
  localStorage.setItem('Username', '');
  localStorage.setItem('token', '');
  localStorage.setItem('Counter', '');
  localStorage.setItem('CellPhoneNum', '');
  localStorage.setItem('isLogin', '');
  return api(options);
};
export var getHomeTableData = function getHomeTableData() {
  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    url: "/contest/winners"
  };
  return api(options);
};
export var getTopUsers = function getTopUsers(filterType, page) {
  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    url: "/v1/users/top?filterType=".concat(filterType, "&page=").concat(page)
  };
  return api(options);
};
export var getTopUsersFilters = function getTopUsersFilters(isRTL) {
  var options = {
    method: 'GET',
    headers: isRTL ? {
      'Content-Type': 'multipart/form-data',
      'Accept-language': 'fa'
    } : {
      'Content-Type': 'multipart/form-data'
    },
    url: "/v1/users/filter"
  };
  return api(options);
}; //deprecated

export var getFilteredData = function getFilteredData(value) {
  var options = {
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    url: "/phonetopusers?type=".concat(value)
  };
  return api(options);
}; //deprecated

export var getFilterCount = function getFilterCount() {
  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    url: "/getFilterCount"
  };
  return api(options);
}; // fetches books based on selected level

export var getBooks = function getBooks(contestType, token, isRTL) {
  var options = {
    method: 'GET',
    headers: isRTL ? {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token,
      'Accept-Language': 'fa'
    } : {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "/v1/books?contestType=".concat(contestType)
  };
  return api(options);
}; // fetches lessons based on selected book

export var getLessons = function getLessons(bookId, token) {
  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "/v1/contests/lessons?bookId=".concat(bookId)
  };
  return api(options);
}; // story writing fetches lessons based on selected book

export var getStoryLessons = function getStoryLessons(bookId, token) {
  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "/v1/stories/subject-lessons?bookId=".concat(bookId)
  };
  return api(options);
}; // fetches lessons based on selected book

export var getLessonsForLearnMode = function getLessonsForLearnMode(bookId, token) {
  var options = {
    method: 'GET',
    // headers: {'Content-Type': 'application/json'},
    // url: `/learn/phonelearnlesson?Counter=${Counter}&Type=${Type}`
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "/v1/learns/lessons?bookId=".concat(bookId)
  };
  return api(options);
}; // creates game based on selected inputs

export var createGame = function createGame(ContestType, book, lessons, token) {
  var options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "/v1/contests/create?lessonId=".concat(lessons, "&contestType=").concat(ContestType, "&fromApp=0&bookId=").concat(book)
  };
  return api(options);
}; // creates learn mode game
// export const createGameLearn = (UserId, LessonId, learnType) => {

export var createGameLearn = function createGameLearn(ContestType, book, lessons, token) {
  var options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "/v1/learns/create?lessonId=".concat(lessons, "&contestType=").concat(ContestType, "&fromApp=0&bookId=").concat(book)
  };
  return api(options);
}; // starts game based on contest id

export var start = function start(ContestId, token) {
  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "/v1/contests/start?contestId=".concat(ContestId, "&isPremium=0")
  };
  return api(options);
}; // starts game based on contest id

export var startLearn = function startLearn(args, token) {
  // const Counter = args[0];
  // const LearnId = args[1];
  // const LessonId = args[2];
  var learnType = args[4];
  var learnId = args[1]; // console.log("args",args)

  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "/v1/learns/start?learnId=".concat(learnId, "&learnType=").concat(learnType)
  };
  return api(options);
}; // starts game based on contest id

export var learnData = function learnData(args, token) {
  var Counter = args[0];
  var learnId = args[1];
  var LessonId = args[2]; // const learnType = args[3];

  var learnType = args[4];
  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "/v1/learns/contest/start?learnId=".concat(learnId, "&learnType=", 3)
  };
  return api(options);
}; // sends game answer

export var answer = function answer(WordId, IsCorrect, ContestId, ContestType, token) {
  var options = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "/v1/contests/answer",
    data: {
      "id": ContestId,
      "wordId": WordId,
      "isCorrect": IsCorrect // "ContestId": ContestId

    }
  };
  return api(options);
}; // sends learn answer

export var learnAnswer = function learnAnswer(UserId, LessonId, contestID, WordId, IsCorrect, token) {
  var options = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "/v1/learns/finish",
    data: {
      // "UserId": UserId,
      // "LessonId": LessonId,
      "Answers": [{
        "id": contestID,
        "wordId": WordId,
        "isCorrect": IsCorrect
      }]
    }
  };
  return api(options);
}; // sends after game is finished

export var finish = function finish(ContestId, token) {
  var options = {
    method: 'POST',
    headers: token ? {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    } : {
      'Content-Type': 'application/json'
    },
    url: "/v1/contests/finish",
    data: {
      "contestId": ContestId
    }
  };
  return api(options);
}; // get results by contest id when clicked on table row

export var contestResult = function contestResult(ContestId) {
  var options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    url: "/contest/result",
    data: {
      "contestid": ContestId
    }
  };
  return api(options);
}; // sends after game is finished

export var result = function result(ContestId) {
  var options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    url: "/contest/phoneresult",
    data: {
      "ContestId": ContestId
    }
  };
  return api(options);
}; // get profile data

export var getProfile = function getProfile(Counter, token) {
  var options = {
    method: 'GET',
    headers: token ? {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    } : {
      'Content-Type': 'application/json'
    },
    url: "v1/users/profile?counter=".concat(Counter)
  };
  return api(options);
}; // get users personal profile data

export var getPersonalProfile = function getPersonalProfile(token) {
  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "v1/users/profile"
  };
  return api(options);
}; // get users personal profile data

export var getPersonalDetail = function getPersonalDetail(token) {
  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "v1/users/detail"
  };
  return api(options);
}; // get users personal profile data

export var personalBookAccess = function personalBookAccess(token) {
  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "v1/users/vocab-access"
  };
  return api(options);
}; // get users personal profile data

export var getPersonalBook = function getPersonalBook(token) {
  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "v1/users/vocab-box"
  };
  return api(options);
}; // get profile data

export var getTestedWords = function getTestedWords(Counter) {
  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    url: "/profile/".concat(Counter),
    data: {
      "Counter": Counter
    }
  };
  return api(options);
}; // get profile data

export var search = function search(name, page) {
  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    // url: `/phonesearchbyname`,
    url: "/v1/users/search?name=".concat(name)
  };
  return api(options);
}; // get books I have not studied yet

export var getUnknownBooks = function getUnknownBooks(Counter, token) {
  var options = {
    method: 'GET',
    headers: token ? {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    } : {
      'Content-Type': 'application/json'
    },
    url: "/v1/users/unPlayed-book?counter=".concat(Counter)
  };
  return api(options);
}; // get my incorrect or slippery words

export var getMySlipperyWords = function getMySlipperyWords(counter, token, page) {
  var options = {
    method: 'GET',
    headers: token ? {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    } : {
      'Content-Type': 'application/json'
    },
    url: "/v1/users/slippery-words?counter=".concat(counter, "&page=").concat(page)
  };
  return api(options);
}; // get my memorized words

export var getMyMemorizedWords = function getMyMemorizedWords(Counter, token, page) {
  var options = {
    method: 'GET',
    headers: token ? {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    } : {
      'Content-Type': 'application/json'
    },
    url: "/v1/users/memorized-words?counter=".concat(Counter, "&page=").concat(page)
  };
  return api(options);
}; // get my new words

export var getMyNewWords = function getMyNewWords(Counter, token, page) {
  var options = {
    method: 'GET',
    headers: token ? {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    } : {
      'Content-Type': 'application/json'
    },
    url: "/v1/users/new-words?counter=".concat(Counter, "&page=").concat(page)
  };
  return api(options);
}; // get flashCards

export var getFlashCards = function getFlashCards(AnswerId, ContestId, Counter, token) {
  var selectedPage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
  var options = {
    method: 'GET',
    headers: token ? {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    } : {
      'Content-Type': 'application/json'
    },
    url: "/v1/users/contestAnswers?contestId=".concat(ContestId, "&answerType=").concat(AnswerId, "&page=").concat(selectedPage)
  };
  return api(options);
}; // get contests

export var getProfileContests = function getProfileContests(counter, token) {
  var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var options = {
    method: 'GET',
    headers: token ? {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    } : {
      'Content-Type': 'application/json'
    },
    url: "/v1/users/contests?counter=".concat(counter, "&page=").concat(page)
  };
  return api(options);
}; // get contests

export var getChartProfileContests = function getChartProfileContests(counter, token) {
  var options = {
    method: 'GET',
    headers: token ? {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    } : {
      'Content-Type': 'application/json'
    },
    url: "/v1/users/all-contests?counter=".concat(counter)
  };
  return api(options);
}; // get popular and recent stories home

export var getPopularAndRecent = function getPopularAndRecent(token) {
  var options = {
    method: 'GET',
    headers: token ? {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    } : {
      'Content-Type': 'application/json'
    },
    url: "/v1/stories/home-list"
  };
  return api(options);
}; // get popular stories page

export var getPopular = function getPopular(token, page) {
  var options = {
    method: 'GET',
    headers: token ? {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    } : {
      'Content-Type': 'application/json'
    },
    url: "/v1/stories/popular?page=".concat(page)
  };
  return api(options);
}; // get recent stories page

export var getRecent = function getRecent(token, page) {
  var options = {
    method: 'GET',
    headers: token ? {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    } : {
      'Content-Type': 'application/json'
    },
    url: "/v1/stories/recent?page=".concat(page)
  };
  return api(options);
}; // Current online players

export var home = function home() {
  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    // url: `${baseUrl}/pages/home`,
    url: "/v1/home-info"
  };
  return api(options);
}; // get single story

export var getSingleStory = function getSingleStory(storyId, token) {
  var options = {
    method: 'GET',
    headers: token ? {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    } : {
      'Content-Type': 'application/json'
    },
    url: "/v1/stories/id=".concat(storyId)
  };
  return api(options);
}; // submit comment on story

export var submitStoryComment = function submitStoryComment(token, comment, StoryId) {
  var options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "/v1/stories/send-comment",
    data: {
      "comment": comment,
      "storyId": StoryId,
      "fromApp": 0
    }
  };
  return api(options);
}; // submit like on story

export var likeStory = function likeStory(StoryID, token) {
  var options = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "/v1/stories/like?storyId=".concat(StoryID)
  };
  return api(options);
}; // submit like on story comment

export var likeStoryComment = function likeStoryComment(commentId, token) {
  var options = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "/v1/stories/like-comment?commentId=".concat(commentId)
  };
  return api(options);
}; // submit story
// export const submitStory = (storyContent, title, subjectId, lessonId, wordsCount, token, picture,storyVoice) => {
//
//     let formData = new FormData();
//     formData.append("storyContent", storyContent);
//     formData.append("title", title);
//     formData.append("subjectId", subjectId);
//     formData.append("lessonId", lessonId);
//     formData.append("wordsCount", wordsCount);
//     formData.append("fromApp", "0");
//     formData.append("storyImage", picture);
//     formData.append("storyVoice", storyVoice);
//
//     const options = {
//         method: 'POST',
//         data: formData,
//         headers: {'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ` + token},
//         url: '/v1/stories',
//     };
//     return api(options);
// }

export var submitStory = function submitStory(storyContent, title, subjectId, lessonId, wordsCount, token, picture, storyVoice) {
  var options = {
    method: 'POST',
    data: {
      storyContent: storyContent,
      title: title,
      subjectId: subjectId,
      lessonId: lessonId,
      wordsCount: wordsCount,
      fromApp: 0
    },
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: '/v1/stories'
  };
  return api(options);
}; //post profile pic

export var uploadProfileImage = function uploadProfileImage(token, file, setUploadPercentage) {
  var formData = new FormData();
  formData.append("userImage", file);
  var options = {
    onUploadProgress: function onUploadProgress(progressEvent) {
      var loaded = progressEvent.loaded,
          total = progressEvent.total;
      var percent = Math.floor(loaded * 100 / total); // console.log(`${loaded}kb of ${total}kb | ${percent}%`);

      if (percent < 100) {
        setUploadPercentage(percent);
      }
    },
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': "Bearer " + token
    },
    url: "/v1/users/upload-userImage"
  };
  return api(options);
}; // recover Password

export var recoverPassword = function recoverPassword(username, token) {
  // console.log("username from api",username)
  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "/v1/users/forget-password?username=".concat(username) // data: {
    //     "username": username
    // }

  };
  return api(options);
}; // reset Password

export var resetPassword = function resetPassword(oldPassword, newPassword, repeatPassword, token) {
  var options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "/v1/users/change-password",
    data: {
      "oldPassword": oldPassword,
      "newPassword": newPassword,
      "repeatPassword": repeatPassword
    }
  };
  return api(options);
}; // change user info

export var changeUserInfo = function changeUserInfo(input, token) {
  var options = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "/v1/users/edit",
    data: {
      "AreaCode": input.AreaCode,
      "Email": input.Email,
      "CellphoneNumber": input.CellphoneNumber,
      "Family": input.Family,
      "GroupCode": input.GroupCode,
      "MainCode": input.MainCode,
      "Name": input.Name,
      "Sex": input.Sex,
      "State": input.State,
      "Username": input.Username,
      "IsStu": input.IsStu
    }
  };
  return api(options);
}; // write story

export var getStoryWords = function getStoryWords(id, token) {
  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    },
    url: "v1/stories/story-words?lessonId=".concat(id)
  };
  return api(options);
}; // get story subjects

export var getStorySubjects = function getStorySubjects() {
  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json' // 'Authorization': `Bearer ` + token

    },
    url: "v1/stories/story-subjects"
  };
  return api(options);
}; // getStates

export var fetchStates = function fetchStates() {
  var options = {
    method: 'GET',
    url: "/v1/states"
  };
  return api(options);
}; // getCityAreas

export var fetchCityAreas = function fetchCityAreas() {
  var options = {
    method: 'GET',
    url: "/v1/city-areas"
  };
  return api(options);
}; // getEducationGroupsInfo

export var fetchEducationGroupsInfo = function fetchEducationGroupsInfo() {
  var options = {
    method: 'GET',
    url: "/v1/educational-groups"
  };
  return api(options);
}; // getEducationGroupsInfo

export var fetchPhoneUserstory = function fetchPhoneUserstory(counter, token) {
  var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var options = {
    method: 'GET',
    headers: token ? {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + token
    } : {
      'Content-Type': 'application/json'
    },
    url: "v1/stories/user-stories?counter=".concat(counter, "&page=").concat(page)
  };
  return api(options);
}; // contact us

export var contactUs = function contactUs(name, tellNum, emailAdd, msg) {
  var options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    url: "/v1/contactUs",
    data: {
      "name": name,
      "telNum": tellNum,
      "emailAdd": emailAdd,
      "msg": msg,
      "fromApp": false
    }
  };
  return api(options);
}; // download app

export var downloadApp = function downloadApp() {
  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    url: "/v1/app-android"
  };
  return api(options);
}; // fetch last 4 articles on wowmagazine

export var getArticles = function getArticles() {
  return axios.get("".concat(baseUrlMagazine, "/wp-json/wp/v2/posts?per_page=4"));
};